import { render } from "./StaffForm.vue?vue&type=template&id=de79702a"
import script from "./StaffForm.vue?vue&type=script&lang=js"
export * from "./StaffForm.vue?vue&type=script&lang=js"

import "./StaffForm.vue?vue&type=style&index=0&id=de79702a&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__